import moment from 'moment'
export default {
  //返回年月日
  filterDateFormat: (value) => {
    if (value == undefined) return;
    return value.substring(0, 19).split('T')[0];
  },
  filterTZ(date) {
    if (!date) return;
    return date.replace('T', ' ').replace('Z', '');
  },
  formatetter(val) {
    if (val) {
      let length = val.length;
      if (length > 5) {
        let str = val.substring(0, 3) + '***' + val.substr(length - 2, 2);
        return str
      } else {
        return val;
      }
    }
    return '无';
  },
  filterAge(date) {
    if (!date) {
      return;
    }
    date = date.replace("Z", "") + "+08:00";
    if (date.split('T')[0] == '0001-01-01') {
      return "";
    }
    let d = new Date().getTime() - new Date(date).getTime();
    let years = parseInt(d / (24 * 60 * 60 * 1000 * 365));
    let months = parseInt(d / (24 * 60 * 60 * 1000 * 30));
    let days = parseInt(d / (24 * 60 * 60 * 1000));

    if (years > 1) {
      return years + '岁';
    }
    if (months > 0) {
      return months + '个月';
    }
    if (days > 0) {
      return days + '天';
    }
    return "";
  },
  appTypeFilter(val) {
    switch (val) {
      case 1:
        return '单机构';
        break;
      case 2:
        return '联盟';
        break;
      default:
        return '';
    }
  },
  filterAppType(val) {
    switch (val) {
      case 1:
        return '医院';
        break;
      case 2:
        return '科室';
        break;
      case 3:
        return '卫健委';
        break;
      case 4:
        return '其他';
        break;
      case 5:
        return '联盟';
        break;
      case 6:
        return '病种';
        break;
      case 8:
        return '单科室';
        break;
      case 9:
        return '机构';
        break;
      case 19:
        return '单病种';
        break;
      case 99:
        return '未开通';
        break;
      case 102:
        return '集团';
        break;
      case 103:
        return '医患咨询';
        break;
      case 104:
        return '科研中心';
        break;
      default:
        return '';
    }
  },

  filterCorpType(val) {
    switch (val) {
      case 1:
        return '医疗机构';
        break;
      case 2:
        return '卫健委';
        break;
      case 3:
        return '保险公司';
        break;
      case 4:
        return '医药企业';
        break;
      case 99:
        return '其他组织';
        break;
      default:
        return '';
    }
  },
  PreMonitor(val) {
    if (val === 0) {
      return '异常';
    } else if (val === 1) {
      return '正常';
    } else if (val === 2) {
      return '未配置';
    } else {
      return '未知';
    }
  },
  formLogStr(val) {
    if (val) {
      let length = val.length;
      if (length > 65) {
        let str = val.substring(0, 30) + '***' + val.substr(length - 30, 30);
        return str
      } else {
        return val;
      }
    } else {
      return '无'
    }
  },
  getTree(data) {
    data.forEach(item => {
      _.assign(item, { key: item.AppType, value: item.AppType + '', title: item.AppTypeName, children: item.Members })
      if (item.Members && item.Members.length) {
        getTree(item.Members)
      }
    })
  }
}




// WEBPACK FOOTER //
// ./src/utils/filter.js